/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]:before{background:url(homepage-chaudiere-reception.3b8296026c6e2a0387a2.svg) center no-repeat}"];
export { styles as styles };
